// Auth API — login, me
import { api } from './client'

export const authApi = {
  // POST /api/auth/login → { token, expiresIn, user }
  login: (username, password) => api.post('/auth/login', { username, password }),

  // POST /api/auth/refresh → { token, expiresIn } — obnova tokenu (prodloužení relace při aktivitě)
  refresh: () => api.post('/auth/refresh', {}),

  // POST /api/auth/register → { ok: true, message } — samoregistrace (žádné heslo).
  // Účet vzniká ve stavu 'pending' (čeká na schválení administrátorem).
  // data: { username, email, first_name?, last_name?, display_name?, request_message? }
  register: (data) => api.post('/auth/register', data),

  // GET /api/auth/me → user object (vyžaduje platný token)
  me: () => api.get('/auth/me'),

  // GET /api/auth/capabilities → { authenticated, access_source, online_source, can_parallel }
  // Funguje i bez tokenu (anonym → access_source='open', online_source='none').
  capabilities: () => api.get('/auth/capabilities'),

  // PUT /api/auth/password → { ok: true } — změna vlastního hesla (vyžaduje aktuální heslo)
  changePassword: (currentPassword, newPassword) => api.put('/auth/password', { currentPassword, newPassword }),

  // POST /api/auth/forgot-password → { ok: true, message } — vyžádá e-mail s odkazem pro reset (vždy 200)
  forgotPassword: (login) => api.post('/auth/forgot-password', { login }),

  // POST /api/auth/reset-password → { ok: true } — nastaví nové heslo podle tokenu z e-mailu
  resetPassword: (token, newPassword) => api.post('/auth/reset-password', { token, newPassword }),
}
